import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";
import { useGet } from "../../customHooks/useGet";
import Table from "react-bootstrap/Table";
import { FaPlus, FaSearch } from "react-icons/fa";

const FloatingButton = ({ onClick, icon, title, position }) => (
  <button
    className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
    onClick={onClick}
    aria-label={title}
    title={title}
    style={{
      background: "linear-gradient(135deg, #007bff, #6610f2)",
      color: "white",
      fontSize: "1.5rem",
      border: "none",
      width: "60px",
      height: "60px",
      transition: "transform 0.2s ease, box-shadow 0.3s ease",
      zIndex: 1050,
      bottom: "20px",
      right: position === "add" ? "20px" : "90px",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    {icon}
  </button>
);

function Modalities() {
  const { data: formsData, error, isLoading } = useGet("/api/academy/modalities?page=0&size=80");
  const [showForm, setShowForm] = useState(false);
  console.log("🔍 formsData:", formsData); // Verifica en la consola

  if (isLoading) return <p>Cargando datos...</p>;
  if (error) return <p>Error al cargar los datos.</p>;

  // Accedemos a formsData.content, si existe. Si no, asignamos un array vacío para evitar errores.
  const formsArray = formsData?.content || [];

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Lista de Modalidades</h1>
      <table className="table table-striped table-hover table-bordered text-center">
          <thead className="table-primary">
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {formsArray.map((form) => (
            <tr key={form.id}>
              <td>{form.id}</td>
              <td>{form.name}</td>
              <td>{form.status ? "Inactivo" : "Activo"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="position-fixed bottom-4 end-0 d-flex flex-column align-items-end me-4 mb-3" style={{ zIndex: 1050 }}>
              {!showForm && (
                <FloatingButton
                  onClick={() => setShowForm(true)}
                  icon={<FaPlus size={24} />}
                  title="Agregar nuevo evento"
                  position="add"
                />
              )}
              </div>
      <Footer /> 
    </div>
  
           
  );
 

}
export default Modalities;
